import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import JiraIssues from '@/views/JiraIssues.vue'
import GitHubPRs from '@/views/GitHubPRs.vue'
import MergedPRs from '@/views/MergedPRs.vue'
import ManageMembers from '@/views/ManageMembers.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: { title: '仪表盘' }
    },
    {
      path: '/jira',
      name: 'JiraIssues',
      component: JiraIssues,
      meta: { title: 'JIRA Issues' }
    },
    {
      path: '/prs',
      name: 'GitHubPRs',
      component: GitHubPRs,
      meta: { title: 'GitHub PRs' }
    },
    {
      path: '/merged-prs',
      name: 'MergedPRs',
      component: MergedPRs,
      meta: { title: '已合并PRs' }
    },
    {
      path: '/manage-members',
      name: 'ManageMembers',
      component: ManageMembers,
      meta: { title: '管理成员' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} - Kafka PMC Tracker`
  next()
})

export default router 